import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartModule } from 'primeng/chart';
import { CardModule } from 'primeng/card';

@Component({
  selector: 'gig-competitor-trend-chart',
  standalone: true,
  imports: [CommonModule, ChartModule, CardModule],
  templateUrl: './competitor-trend-chart.component.html',
  styleUrl: './competitor-trend-chart.component.scss'
})
export class CompetitorTrendChartComponent implements OnInit {

    @Input() sourceData: any;

    labelData: any;
    data: any;
    options: any;
    loading: boolean = false;
    ngOnInit(): void {
        this.labelData = [];
        this.data = [];

        if(this.sourceData) {
            this.labelData = this.sourceData.map(e => this.getMonthName(e.month, e.year));
            this.data = this.sourceData.map(e => e.searchVolume);
        } else {
            this.labelData = [];
            this.data = [];
        }

        this.initializeChart();

        this.loading = true;
        setTimeout(() => {
            this.loading = false;
        }, 300);

    }

    initializeChart(): void {

        this.data = {
            labels: this.labelData,
            datasets: [
                {
                    label: 'Search Volume',
                    backgroundColor: '#731ffe',
                    data: this.data
                }
            ]
        };

        this.options = {
            maintainAspectRatio: false,
            aspectRatio: 0.8,
            animation: {
                duration: 0  // Disable animations for faster rendering
            },
            plugins: {
                legend: {
                    display: false
                }
            },
            scales: {
                x: {
                    ticks: {
                        display:false
                    },
                    grid: {
                        display: false
                    }
                },
                y: {
                    ticks: {
                        display: false
                    },
                    grid: {
                        display: false
                    }
                }

            }
        };
    }

    getMonthName(monthNumber: number, year: number): string {
        const monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"];
        return monthNames[monthNumber - 1] + ' ' + year;
    }
}
